"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalkNode = void 0;
const getNormalizedType = (val) => {
    return Array.isArray(val)
        ? 'array'
        : typeof val === 'object'
            ? 'object'
            : 'value';
};
function defaultPathFormatter(node) {
    return node.isArrayMember ? `[${node.key}]` : `["${node.key}"]`;
}
class WalkNode {
    constructor(val, isRoot = false, isArrayMember = false, nodeType = 'value', rawType = 'undefined', executedCallbacks = [], key, parent) {
        this.val = val;
        this.isRoot = isRoot;
        this.isArrayMember = isArrayMember;
        this.nodeType = nodeType;
        this.rawType = rawType;
        this.executedCallbacks = executedCallbacks;
        this.key = key;
        this.parent = parent;
        this._children = undefined;
        this.id = WalkNode._idx++;
    }
    static fromRoot(obj) {
        return new WalkNode(obj, true, false, getNormalizedType(obj), typeof obj, [], undefined, undefined);
    }
    static fromObjectKey(parent, key) {
        return new WalkNode(parent.val[key], false, false, getNormalizedType(parent.val[key]), typeof parent.val[key], [], key, parent);
    }
    static fromArrayIndex(parent, index) {
        return new WalkNode(parent.val[index], false, true, getNormalizedType(parent.val[index]), typeof parent.val[index], [], index, parent);
    }
    canBeCompared() {
        return this.nodeType !== 'value' && this.val !== null && !Object.is(NaN, this.val);
    }
    sameAs(other) {
        if (!this.canBeCompared() || this.nodeType !== other.nodeType)
            return false;
        if (this.val === null || Object.is(NaN, this.val))
            return false;
        return Object.is(this.val, other.val);
    }
    getPath(pathFormat) {
        if (this.isRoot)
            return "";
        pathFormat = pathFormat || defaultPathFormatter;
        return this.parent.getPath(pathFormat) + pathFormat(this);
    }
    get children() {
        if (typeof this._children === 'undefined')
            this._children = [...this.getChildren()];
        return this._children;
    }
    *getChildren() {
        if (this.nodeType === 'array') {
            for (let i = 0; i < this.val.length; i++)
                yield WalkNode.fromArrayIndex(this, i);
        }
        else if (this.nodeType === 'object') {
            if (this.val === null)
                return;
            for (let key of Object.keys(this.val))
                yield WalkNode.fromObjectKey(this, key);
        }
    }
    get siblings() {
        return [...this.getSiblings()];
    }
    *getSiblings() {
        if (!this.parent)
            return;
        for (let child of this.parent.children)
            if (this.key !== child.key)
                yield child;
    }
    get ancestors() {
        return [...this.getAncestors()];
    }
    *getAncestors() {
        let next = this.parent;
        while (next) {
            yield next;
            next = next.parent;
        }
    }
    get descendants() {
        return [...this.getDescendants()];
    }
    *getDescendants() {
        for (const child of this.getChildren()) {
            yield child;
            yield* child.getDescendants();
        }
    }
}
exports.WalkNode = WalkNode;
WalkNode._idx = 0;
